var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"btn btn-link no-decoration",attrs:{"to":"/documents"}},[_c('i',{staticClass:"fas fa-file-alt"}),_vm._v(" "+_vm._s(_vm.$t("documents"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }